export const useAlternateLocale = () => {
  const { locales, locale } = useI18n()
  const alternateLocales = computed(() => locales.value.filter(l => !!l.domain && l.code !== locale.value))
  return { alternateLocales }
}
